import yup from '../../../config/yup';

export const executeValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('execute'),
  action: yup.string().default('EXECUTE').required('Action is required'),
  command: yup
    .string()
    .default('EXECUTE')
    .required('Command is required')
    .matches(/^EXECUTE\s+\S+/i, "Command must start with 'EXECUTE' followed by at least one word"),
});
